import { render, staticRenderFns } from "./basic-salary-history.vue?vue&type=template&id=14ebf262&scoped=true&"
import script from "./basic-salary-history.vue?vue&type=script&lang=js&"
export * from "./basic-salary-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ebf262",
  null
  
)

export default component.exports